import React from "react"
import { Typography } from '@mui/material'
import ManageDatasetsPermissions from './components/ManageDatasetsPermissions'

export default function ManageDatasets() {
    return (
        <section>
            <Typography variant="h2">Manage Datasets</Typography>
            <ManageDatasetsPermissions/>
        </section>
    )
} 